import type Highcharts from "highcharts";

declare module "highcharts" {
  interface YAxisOptions {
    initialUserMin?: number | null;
    initialUserMax?: number | null;
  }
  interface XAxisOptions {
    initialUserMin?: number | null;
    initialUserMax?: number | null;
  }
}

export default function handleAxisInitialUserMinMax(H: typeof Highcharts) {
  H.addEvent(H.Axis, "afterInit", e => {
    const axis: Highcharts.Axis = e?.target;
    if (Object.keys(axis.userOptions).includes("initialUserMin")) {
      axis.userMin = axis.userOptions.initialUserMin;
      axis.userMax = axis.userOptions.initialUserMax;
      // do not reuse these values
      // they are meant to be read only once at chart initialization for initial axis
      // axis can be init more than once for different scopes
      delete axis.userOptions.initialUserMin;
      delete axis.userOptions.initialUserMax;
    }
  });
}
